/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type SystemSettingResponseDtoValue
 * 
 * @export
 */
export type SystemSettingResponseDtoValue = boolean | number | string;

export function SystemSettingResponseDtoValueFromJSON(json: any): SystemSettingResponseDtoValue {
    return SystemSettingResponseDtoValueFromJSONTyped(json, false);
}

export function SystemSettingResponseDtoValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSettingResponseDtoValue {
    if (json == null) {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'boolean') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function SystemSettingResponseDtoValueToJSON(json: any): any {
    return SystemSettingResponseDtoValueToJSONTyped(json, false);
}

export function SystemSettingResponseDtoValueToJSONTyped(value?: SystemSettingResponseDtoValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

